// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36KMD","newExpiryDate":"styles_newExpiryDate__ALMBH","footer":"styles_footer__2TSm4"};